import { MapStyle, Maps } from '@/ui';
import { getChannel, getDocument, getPlaceId, normalizeSelect } from '@lib/server';
import { Place } from '@types';

import { BlockBase, getMarginClassNames } from './utils';

export async function Map({
  params,
  id,
  margin,
  ...data
}: {
  places: Place[];
  mapStyle: keyof typeof MapStyle;
} & BlockBase) {
  if (!data.places.length) {
    return null;
  }

  const channel = await getChannel(decodeURIComponent(params.domain));
  if (!channel?.channelId) {
    return null;
  }

  const placeId = await getPlaceId(channel, decodeURIComponent(params.venue || ''));

  let places = [];
  let accessToken = '';
  if (!data.places?.[0]?.default?.geoLocation) {
    accessToken = channel.apps?.mapbox?.active ? channel.apps.mapbox.token : '';

    for (const place of data.places) {
      const { fields } = await getDocument<Place>('places', place.id, {
        tags: [channel.channelId],
        depth: 0,
        status: 'published',
        select: ['fields.default.geoLocation', 'fields.custom.displayName'],
      });
      places.push({ ...fields, primary: placeId?.placeId === place.id });
    }
  } else {
    places = data.places.map((place) => ({ ...place, primary: placeId?.placeId === place.id }));
  }

  return (
    <Maps
      id={id}
      className={getMarginClassNames(margin)}
      accessToken={accessToken}
      style={normalizeSelect(data.mapStyle, true) as keyof typeof MapStyle}
      locations={places?.map((place) => ({
        latitude: place?.default?.geoLocation?.latitude || 0,
        longitude: place?.default?.geoLocation?.longitude || 0,
        name: place?.custom?.displayName || '',
        primary: place?.primary,
      }))}
    />
  );
}
